import { FC } from 'react'
import { UserAccount } from 'components/User'
import { UserProtectedRoute } from 'routes'

const UserAccountPage: FC = () => {
  return (
    <UserProtectedRoute>
      <UserAccount />
    </UserProtectedRoute>
  )
}

export default UserAccountPage
